/** Set of African countries (GeoJSON names + DB names) */
export const AFRICAN_COUNTRIES = new Set([
    'Algeria',
    'Angola',
    'Benin',
    'Botswana',
    'Burkina Faso',
    'Burundi',
    'Cabo Verde',
    'Cameroon',
    'Central African Rep.',
    'Central African Republic',
    'Chad',
    'Comoros',
    'Congo',
    'Congo, Dem. Rep.',
    'Congo, Rep.',
    'Côte d’Ivoire',
    "Côte d'Ivoire",
    'Dem. Rep. Congo',
    'Djibouti',
    'Egypt',
    'Egypt, Arab Rep.',
    'Eq. Guinea',
    'Equatorial Guinea',
    'Eritrea',
    'Eswatini',
    'eSwatini',
    'Ethiopia',
    'Gabon',
    'Gambia',
    'Gambia, The',
    'Ghana',
    'Guinea',
    'Guinea-Bissau',
    'Kenya',
    'Lesotho',
    'Liberia',
    'Libya',
    'Madagascar',
    'Malawi',
    'Mali',
    'Mauritania',
    'Mauritius',
    'Morocco',
    'Mozambique',
    'Namibia',
    'Niger',
    'Nigeria',
    'Rwanda',
    'S. Sudan',
    'South Sudan',
    'São Tomé and Príncipe',
    'Senegal',
    'Seychelles',
    'Sierra Leone',
    'Somalia',
    'Somaliland',
    'South Africa',
    'Sudan',
    'Tanzania',
    'Togo',
    'Tunisia',
    'Uganda',
    'Zambia',
    'Zimbabwe',
]);
export function isAfricanCountry(country) {
    return AFRICAN_COUNTRIES.has(country);
}
/** Canonical list of African countries using DB naming conventions for UI selectors */
export const AFRICAN_COUNTRY_LIST = [
    'Algeria',
    'Angola',
    'Benin',
    'Botswana',
    'Burkina Faso',
    'Burundi',
    'Cabo Verde',
    'Cameroon',
    'Central African Republic',
    'Chad',
    'Comoros',
    'Congo, Dem. Rep.',
    'Congo, Rep.',
    'Côte d’Ivoire',
    'Djibouti',
    'Egypt, Arab Rep.',
    'Equatorial Guinea',
    'Eritrea',
    'Eswatini',
    'Ethiopia',
    'Gabon',
    'Gambia, The',
    'Ghana',
    'Guinea',
    'Guinea-Bissau',
    'Kenya',
    'Lesotho',
    'Liberia',
    'Libya',
    'Madagascar',
    'Malawi',
    'Mali',
    'Mauritania',
    'Mauritius',
    'Morocco',
    'Mozambique',
    'Namibia',
    'Niger',
    'Nigeria',
    'Rwanda',
    'Senegal',
    'Seychelles',
    'Sierra Leone',
    'Somalia',
    'South Africa',
    'South Sudan',
    'Sudan',
    'São Tomé and Príncipe',
    'Tanzania',
    'Togo',
    'Tunisia',
    'Uganda',
    'Zambia',
    'Zimbabwe',
].sort((a, b) => a.localeCompare(b));
/** Mapping from country names and aliases to ISO 3166-1 alpha-3 codes */
export const COUNTRY_TO_ISO3 = {
    'Algeria': 'DZA',
    'Angola': 'AGO',
    'Benin': 'BEN',
    'Botswana': 'BWA',
    'Burkina Faso': 'BFA',
    'Burundi': 'BDI',
    'Cabo Verde': 'CPV',
    'Cameroon': 'CMR',
    'Central African Rep.': 'CAF',
    'Central African Republic': 'CAF',
    'Chad': 'TCD',
    'Comoros': 'COM',
    'Congo': 'COG',
    'Congo, Dem. Rep.': 'COD',
    'Congo, Rep.': 'COG',
    'Côte d’Ivoire': 'CIV',
    "Côte d'Ivoire": 'CIV',
    'Dem. Rep. Congo': 'COD',
    'Djibouti': 'DJI',
    'Egypt': 'EGY',
    'Egypt, Arab Rep.': 'EGY',
    'Eq. Guinea': 'GNQ',
    'Equatorial Guinea': 'GNQ',
    'Eritrea': 'ERI',
    'Eswatini': 'SWZ',
    'eSwatini': 'SWZ',
    'Ethiopia': 'ETH',
    'Gabon': 'GAB',
    'Gambia': 'GMB',
    'Gambia, The': 'GMB',
    'Ghana': 'GHA',
    'Guinea': 'GIN',
    'Guinea-Bissau': 'GNB',
    'Kenya': 'KEN',
    'Lesotho': 'LSO',
    'Liberia': 'LBR',
    'Libya': 'LBY',
    'Madagascar': 'MDG',
    'Malawi': 'MWI',
    'Mali': 'MLI',
    'Mauritania': 'MRT',
    'Mauritius': 'MUS',
    'Morocco': 'MAR',
    'Mozambique': 'MOZ',
    'Namibia': 'NAM',
    'Niger': 'NER',
    'Nigeria': 'NGA',
    'Rwanda': 'RWA',
    'S. Sudan': 'SSD',
    'South Sudan': 'SSD',
    'São Tomé and Príncipe': 'STP',
    'Senegal': 'SEN',
    'Seychelles': 'SYC',
    'Sierra Leone': 'SLE',
    'Somalia': 'SOM',
    'Somaliland': 'SOM',
    'South Africa': 'ZAF',
    'Sudan': 'SDN',
    'Tanzania': 'TZA',
    'Togo': 'TGO',
    'Tunisia': 'TUN',
    'Uganda': 'UGA',
    'Zambia': 'ZMB',
    'Zimbabwe': 'ZWE',
};
/** Mapping from ISO 3166-1 alpha-3 codes to canonical database country names */
export const ISO3_TO_COUNTRY = {
    DZA: 'Algeria',
    AGO: 'Angola',
    BEN: 'Benin',
    BWA: 'Botswana',
    BFA: 'Burkina Faso',
    BDI: 'Burundi',
    CPV: 'Cabo Verde',
    CMR: 'Cameroon',
    CAF: 'Central African Republic',
    TCD: 'Chad',
    COM: 'Comoros',
    COD: 'Congo, Dem. Rep.',
    COG: 'Congo, Rep.',
    CIV: 'Côte d’Ivoire',
    DJI: 'Djibouti',
    EGY: 'Egypt, Arab Rep.',
    GNQ: 'Equatorial Guinea',
    ERI: 'Eritrea',
    SWZ: 'Eswatini',
    ETH: 'Ethiopia',
    GAB: 'Gabon',
    GMB: 'Gambia, The',
    GHA: 'Ghana',
    GIN: 'Guinea',
    GNB: 'Guinea-Bissau',
    KEN: 'Kenya',
    LSO: 'Lesotho',
    LBR: 'Liberia',
    LBY: 'Libya',
    MDG: 'Madagascar',
    MWI: 'Malawi',
    MLI: 'Mali',
    MRT: 'Mauritania',
    MUS: 'Mauritius',
    MAR: 'Morocco',
    MOZ: 'Mozambique',
    NAM: 'Namibia',
    NER: 'Niger',
    NGA: 'Nigeria',
    RWA: 'Rwanda',
    STP: 'São Tomé and Príncipe',
    SEN: 'Senegal',
    SYC: 'Seychelles',
    SLE: 'Sierra Leone',
    SOM: 'Somalia',
    ZAF: 'South Africa',
    SSD: 'South Sudan',
    SDN: 'Sudan',
    TZA: 'Tanzania',
    TGO: 'Togo',
    TUN: 'Tunisia',
    UGA: 'Uganda',
    ZMB: 'Zambia',
    ZWE: 'Zimbabwe',
};
/**
 * Resolves an ISO-3166-1 alpha-3 code or country name/alias into the canonical DB country name.
 * e.g. 'TUN' -> 'Tunisia', 'CIV' -> 'Côte d’Ivoire', 'Côte d\'Ivoire' -> 'Côte d’Ivoire'
 */
export function resolveCountryName(identifier) {
    if (!identifier)
        return '';
    const trimmed = identifier.trim();
    const upper = trimmed.toUpperCase();
    if (ISO3_TO_COUNTRY[upper]) {
        return ISO3_TO_COUNTRY[upper];
    }
    const normalized = trimmed.replace(/'/g, '’');
    if (COUNTRY_TO_ISO3[normalized]) {
        const iso = COUNTRY_TO_ISO3[normalized];
        return ISO3_TO_COUNTRY[iso] ?? normalized;
    }
    if (COUNTRY_TO_ISO3[trimmed]) {
        const iso = COUNTRY_TO_ISO3[trimmed];
        return ISO3_TO_COUNTRY[iso] ?? trimmed;
    }
    return trimmed;
}
/**
 * Resolves a country name or ISO3 code into the standardized 3-letter uppercase ISO code.
 * e.g. 'Tunisia' -> 'TUN', 'Côte d’Ivoire' -> 'CIV', 'civ' -> 'CIV'
 */
export function resolveCountryIso3(identifier) {
    if (!identifier)
        return null;
    const trimmed = identifier.trim();
    const upper = trimmed.toUpperCase();
    if (ISO3_TO_COUNTRY[upper]) {
        return upper;
    }
    const normalized = trimmed.replace(/'/g, '’');
    return COUNTRY_TO_ISO3[normalized] ?? COUNTRY_TO_ISO3[trimmed] ?? null;
}
export const countryToIso3 = resolveCountryIso3;
export const iso3ToCountry = resolveCountryName;
//# sourceMappingURL=countries.js.map